import { render, staticRenderFns } from "./CheckResumenTiempos.vue?vue&type=template&id=48f59496&"
import script from "./CheckResumenTiempos.vue?vue&type=script&lang=ts&"
export * from "./CheckResumenTiempos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('48f59496', component.options)
    } else {
      api.reload('48f59496', component.options)
    }
    module.hot.accept("./CheckResumenTiempos.vue?vue&type=template&id=48f59496&", function () {
      api.rerender('48f59496', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Informes/InformeResumenTiempos/CheckResumenTiempos.vue"
export default component.exports